module.exports = __webpack_public_path__ + "dlssrvtline2/img/vi-slider-3.jpg?eeb69faf";